import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams, useSearchParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CustomTabs from "components/Shared/CustomTabs";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

import RouteShipmentBasicDetail from "./RouteShipmentComponents/RouteShipmentBasicDetail";
import RouteShipmentStopsTab from "./RouteShipmentComponents/RouteShipmentStopsTab"
import {
  useGetRouteShipmentDetailQuery,
} from "store/services/routeShipmentApi";

import {
  RouteShipmentDetailContext,
  useRouteShipmentDetailContext,
} from "contexts/RouteShipmentDetailContext";
import RouteVehicleDepartureAssign from "./RouteShipmentComponents/RouteDriverVehicleAssign";

const RouteShipmentDetailScreen = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "route";
  const breadcrumb = [
    { title: "Route Shipments", path: "/app/crm/route-shipment/list" },
    { title: "Route Shipment Detail" },
  ];

  const {
    data: routeShipmentDetail,
    isLoading: loadingRouteShipment,
    error,
  } = useGetRouteShipmentDetailQuery(id);

  const routeTabs = [
    { label: "Stops", value: "route", badgeCount: routeShipmentDetail?.routeStops?.length },
    { label: "Vehicles", value: "vehicles" },
  ];

  return (
    <RouteShipmentDetailContext.Provider value={{ routeShipmentDetail, loadingRouteShipment }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingRouteShipment}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <RouteShipmentBasicDetail />
          <Divider />

          <CustomTabs tabs={routeTabs} activeTab={activeTab} />

          {!loadingRouteShipment ? (
            <>
              <CustomTabPanel activeTab={activeTab} value="route">
                <RouteShipmentStopsTab />
              </CustomTabPanel>
              <CustomTabPanel activeTab={activeTab} value="vehicles">
                <RouteVehicleDepartureAssign />
              </CustomTabPanel>
            </>
          ) : (
            <RowsSkeleton />
          )}
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </RouteShipmentDetailContext.Provider>
  );
};

export default RouteShipmentDetailScreen;

const PageActions = () => {
  const { routeShipmentDetail } = useRouteShipmentDetailContext();

  return (
    <div className="flex space-x-4">
      <Link to={`/app/crm/route-shipment/${routeShipmentDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
